
export default class ShipperDetail {
    constructor() {

        this.id = 0;
        this.shipperName = '';
        this.shipperAddressLine1 = '';
        this.shipperAddressLine2 = '';
        this.shipperCity = '';
        this.shipperCounty = '';
        this.shipperCountry = '';
        this.shipperPostcode = '';
        this.shipperVatNumber = '';
        this.shipperContactId = 0;
        this.shipperContactFullName = '';
        this.shipperContactTitle = '';
        this.shipperContactFirstName = '';
        this.shipperContactLastName = '';
        this.shipperContactPhone = '';
        this.shipperContactEmail = '';
        this.shipperContactDepartment = '';
        this.shipperContacts = [];
        this.shipperRef = '';
    }
}
